module.exports = __webpack_public_path__ + "static/media/ке.247a5586.mp3";